/* global wp */
import HubConnector from './hub-connector'
// Styles.
import './hub-connector.scss'

const { createRoot } = wp.element

const container = document.getElementById('wpmudev-hub-connector')
if (container !== null) {
  const root = createRoot(container)
  root.render(<HubConnector/>)
}